import { ALL_STAR_SLUG, WLL_ALL_STAR_SLUG } from '../../Constant/allStar'
import { callGraphQL } from '../utils/request'
import { submitAllStarVote } from './allStar.mutations'
import { allStarPlayersQuery } from './allStar.queries'
import {
  SubmitAllStarVoteResponse,
  SubmitAllStarObj,
  AllStarPlayersResponse,
  AllStarEvent,
} from './allStar.types'

/**
 * Submit all star vote for a single player
 */
export async function saveAllStarVote(
  input: SubmitAllStarObj
): Promise<SubmitAllStarObj | null> {
  try {
    const gamification = input?.firebaseId ? 1 : 0
    const res = await callGraphQL<SubmitAllStarVoteResponse>(
      submitAllStarVote,
      { input },
      gamification
    )
    return res?.submitAllStarVote ?? null
  } catch (err) {
    console.error(err)
    return null
  }
}

/**
 * Fetch all star players for a given league
 */
export async function fetchAllStarPlayers(): Promise<AllStarEvent | null> {
  try {
    const res = await callGraphQL<AllStarPlayersResponse>(allStarPlayersQuery, {
      slug: ALL_STAR_SLUG,
    })
    return res?.event ?? null
  } catch (err) {
    console.error(err)
    return null
  }
}

/**
 * Fetch all star players for a given league
 */
export async function fetchWLLAllStarPlayers(): Promise<AllStarEvent | null> {
  try {
    const res = await callGraphQL<AllStarPlayersResponse>(allStarPlayersQuery, {
      slug: WLL_ALL_STAR_SLUG,
    })
    return res?.event ?? null
  } catch (err) {
    console.error(err)
    return null
  }
}
